import classNames from 'classnames';
import {
  dropdownDefaultStyles,
  dropdownHideDisabledOptionStyles,
  Theme,
} from './styles';
import {
  MultiValueLabel,
  ClearIndicator,
  LoadingIndicator,
  DropdownIndicator,
  XIndicator,
} from './components';
import { createFilter } from 'react-select3';

const utilizeFastFilterOptions = (props: Props) => {
  let enhancedProps = {
    ...props,
    filterOptions: null,
  };

  if (props.isSearchable) {
    enhancedProps.filterOptions = createFilter({ ignoreAccents: false });
  }

  return enhancedProps;
};

export const enhanceProps = (props: Props) => {
  const components = Object.assign(
    {
      MultiValueLabel,
      DropdownIndicator,
      LoadingIndicator,
      ClearIndicator,
    },
    props.components || {}
  );

  let enhancedProps = {
    ...props,
    isSearchable: props.isCreatable ? true : props.isSearchable,
    theme: Theme,
    className: classNames(props.className, 'sl-dropdown-container'),
    classNamePrefix: 'sl-dropdown',
    styles: props.hideDisabledOptions
      ? { ...dropdownHideDisabledOptionStyles }
      : { ...dropdownDefaultStyles },
    components: components,
    clearRenderer: XIndicator,
  };

  enhancedProps = utilizeFastFilterOptions(enhancedProps);

  return enhancedProps;
};

export const getNoResultsText = noOptionsMessage => {
  return noOptionsMessage ? noOptionsMessage() : undefined;
};

export const getLoadingPlaceholder = loadingMessage => {
  return loadingMessage ? loadingMessage() : undefined;
};
